import {ValueObject} from '@s-ui/domain'

export default class UserDataCommonValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {String} deps.userID
   * @param {String} deps.UID
   * @param {String} deps.token
   * @param {String} deps.email
   * @param {String} deps.phone
   * @param {String} deps.lastName
   * @param {String} deps.name
   * @param {String} deps.avatar
   * @param {Number} deps.expires - timestamp
   */
  constructor({
    contractId = null,
    userID: userid,
    UID: uid,
    token,
    email = null,
    phone = null,
    lastName = null,
    name = null,
    avatar = null,
    expires = null,
    provinceID = null,
    emailConfirmed = null,
    zipCode = null,
    hidePhone = null
  }) {
    super({
      contractId,
      userid,
      uid,
      email,
      phone,
      lastName,
      name,
      avatar,
      provinceID,
      token,
      expires,
      isEmailConfirmed: emailConfirmed,
      zipCode,
      hidePhone
    })
  }

  getName() {
    return this._name
  }

  getContractId() {
    return this._contractId
  }
}
